module.exports = __webpack_public_path__ + "static/img/station2.237f50d4.png";